import { BaseMethodReturnType } from 'src/types/commonTypes';

export interface IConnectionInfoSubsystemStrategy {
  hasInternetAccess(): Promise<BaseMethodReturnType<boolean>>;
  listenHasInternetAccess(
    callback: (hasInternetAccess: boolean) => void
  ): Promise<BaseMethodReturnType<{ remove: () => void }>>;
}

export type EventData = {
  isInternetConnected: boolean;
};

export enum ConnectionInfoStrategy {
  BROWSER = 'browser',
  EVENT = 'jwebEvent'
}
